import {Form, Select, Spin} from "antd";
import {useEffect, useMemo, useState} from "react";
import {getArgList} from "@/services/product.ts";
import {isEmpty} from "lodash-es";

type IProps = {
  formRef: any;
  fn: (data: any[]) => void,
  selectedFormRows: any[]
}

export const SpecsConfigure = (props: IProps) => {
  const {selectedFormRows = [], fn, formRef} = props;

  const [form] = Form.useForm()
  const [selected, setSelected] = useState<any[]>([])
  const [option, setOption] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getOptions()
  }, []);

  const getOptions = async () => {
    try {
      setLoading(true)
      const list: any = await getArgList({enabled: true});
      if (!Array.isArray(list)) {
        return;
      }
      setOption(list?.filter((item: any) => item.argType === 'CHOOSE')?.map(item => ({
        ...item,
        label: item.argName,
        value: item.argCode,
        type: item.argType,
        data: item.argValueJson?.list  || undefined
      })));
      setLoading(false)
    }catch (e){
      setLoading(false)
    }
  }

  const newData = useMemo(() => {
    if(!isEmpty(option)){
      if (!isEmpty(selectedFormRows)) {
        const keys = selectedFormRows.reduce((res, item) => {
          res.push(item.value)
          return res
        }, [])
        return option.filter(item => !keys.includes(item.value))
      }
      return option
    }
  }, [selectedFormRows, option])

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        console.log(selected)
        fn(selected)
        resolve(values)
      }).catch(reject);
    })
  }

  if (formRef) {
    formRef.current.onFinish = onFinish;
  }

  return <Form form={form} layout={'vertical'}>
    <Spin spinning={loading}>
      <Form.Item name={'product'} label={'产品参数'} required={true}
                 rules={[{required: true, message: '产品参数不能为空'}]}>
        <Select placeholder={'请选择产品参数'} mode={'multiple'} optionFilterProp={'label'} options={newData} onChange={(_, options: any[]) => setSelected(options)}/>
      </Form.Item>
    </Spin>
  </Form>
}

